const getDevice = () => {

	const w = window.innerWidth as Number;
	const breakpoints = {
		xl: 1400,
		lg: 1300,
		md: 1130,
		sm: 750,
		xs: 500
	}
	let breakpoint: String;
	if (w < breakpoints.lg && w > breakpoints.md) {
		breakpoint = 'lg';
	}
	else if (w < breakpoints.md && w > breakpoints.sm) {
		breakpoint = 'md';
	}
	else if (w < breakpoints.sm && w > breakpoints.xs) {
		breakpoint = 'sm';
	}
	else if (w <= breakpoints.xs) {
		breakpoint = 'xs'
	}
	else {
		breakpoint = 'xl';
	}
	return breakpoint;
};




getDevice();